export enum TicketState {
    New = 1,
    Accepted = 2,
    Cancelled = 3,
    RedirectedToCategory = 4,
    Called = 5,
    RedirectedToDesk = 6,
    PausedIndefinitely = 7,
    PausedForTime = 8
}